import { format, isValid } from 'date-fns';

export const getActionFormattedDate = (sourceDate = new Date()) => {
  if (sourceDate === null) {
    return '';
  }

  const date = new Date(sourceDate);

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
};
